import React from "react";
import { useSelector } from "react-redux";
import styles from "./DocumentsContainer.module.css";
import { CustomIconButtonLink, CustomTooltip, icon, IconComponent } from "../../../../common/components";
import { matchTypeIcon } from "../../../../common/utils";
import { translate } from "../../../../common/providers";
import { NavUtils } from "../../../../navigation";

const DocumentsContainer = () => {
	const selectedDocument = useSelector(({ notesSelectedDocument }) => notesSelectedDocument.selectedDocument);
	return (
		<div className={styles.container}>
			<IconComponent
				color="var(--blue-500)"
				icon={icon[matchTypeIcon({ name: selectedDocument?.name })]}
				size="md"
			/>
			<CustomTooltip showWhenOverflow title={selectedDocument?.name}>
				<div className={styles.documentName}>{selectedDocument?.name}</div>
			</CustomTooltip>
			<CustomTooltip title={translate("common:navigation.go-to-my-review")}>
				<CustomIconButtonLink
					openInNewTab
					icon={icon.faUpRightFromSquare}
					size="sm"
					to={NavUtils.goToSmartReview({
						projectId: selectedDocument.projectId,
						documentId: selectedDocument.id,
						pageStart: 0,
					})}
					variant="outlined"
				/>
			</CustomTooltip>
		</div>
	);
};

export default DocumentsContainer;
